export default __webpack_public_path__ + "static/media/symbols.e8532fbb.svg";